module.exports = __webpack_public_path__ + "img/710.4e625f95.jpg";